/**
 * Assistants with a screen of their own (ADR 0060 phase 5).
 *
 * Chat is one surface. An assistant whose work is a form — build a quote,
 * pick products, watch totals — opens on its page instead, with the chat
 * as a helper beside it. The Hub card and the landing page consult this
 * map; everything else keeps routing to `#/chat/<slug>`.
 */
const PAGE_ROUTES: Record<string, string> = {
  "service-catalog": "#/service-catalog",
  // A bid is a folder of files with a requirement matrix at its spine —
  // a workspace, not a conversation. The chat is its helper.
  "bid-writing": "#/bid",
};

/** The page route for an assistant, or the chat route when it has none. */
export function assistantHref(slug: string): string {
  return PAGE_ROUTES[slug] ?? `#/chat/${slug}`;
}

export function hasOwnPage(slug: string): boolean {
  return slug in PAGE_ROUTES;
}
